import './Preloader.css';
function Preloader() {
    return (
        <div className="preloader">
            Loading...
        </div>
    )
}

export default Preloader